import ReactGA4 from 'react-ga4';
import { AnalyticsGTM } from '@quicktools/shared-components/services/analytics-gtm';

import { TOOL_NAME, VERSION } from '../../configs';

import { IFileUpload, IPageClick, IPageOpen, IUploadStart } from './types';

class Analytics extends AnalyticsGTM {
  pageOpen(params: IPageOpen) {
    this.sendGaEvent('page_open', params);
    this.hjEvent('page_open');
  }

  uploadStart(params: IUploadStart) {
    this.sendGaEvent('upload_start', params);
    this.hjEvent('upload_start');
  }

  fileUpload(params: IFileUpload) {
    this.sendGaEvent('file_upload', params);
    this.hjEvent('file_upload');
  }

  sendPageClick(params: IPageClick) {
    this.sendGaEvent('page_click', params);
    this.hjEvent('page_click');
  }
}

export default new Analytics(
  {
    VERSION,
    TOOL_NAME,
  },
  ReactGA4,
);
